import { all, put, takeLatest } from 'redux-saga/effects';
import { GET_SYSTEM_PARAMETERS, SAVE_SYSTEM_PARAMETERS } from './constants';
import Api from '../../commons/api';
import * as systemParametersActions from './action';

const controller = 'system-parameters';

function* getSystemParameters() {
  try {
    const { data } = yield Api.get(`${controller}`);
    if (data.length === 0) {
      yield put(systemParametersActions.systemParametersNotFound());
      return;
    }
    yield put(systemParametersActions.getSystemParametersSuccess(data[0]));
  } catch (err) {
    yield put(systemParametersActions.getSystemParametersFailed(err));
  }
}

function* saveSystemParameters({ payload }) {
  try {
    const { data } = yield Api.post(`${controller}`, payload);
    yield put(systemParametersActions.saveSystemParametersSuccess(data));
  } catch (err) {
    yield put(systemParametersActions.saveSystemParametersFailed(err));
  }
}

function* ActionWatcher() {
  yield takeLatest(GET_SYSTEM_PARAMETERS, getSystemParameters);
  yield takeLatest(SAVE_SYSTEM_PARAMETERS, saveSystemParameters);
}

export default function* SystemParametersSaga() {
  yield all([ActionWatcher()]);
}
